export default __webpack_public_path__ + "static/artifakt-legend-medium-24852121fbf6857f4a731513a776d213.woff";